// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"52":"514a0416","95":"f5e9512f","134":"bb116a79","141":"f904fdf4","466":"84ecc221","515":"6071fe79","618":"84ecc221","714":"88b1bdf4","763":"bfccf26e","825":"2f3d3a82","867":"f904fdf4"}[chunkId] + ".chunk.css";
};